module.exports = "/_next/static/images/row2-2-2x-0f15062a0ba32111a4429343076e0f96.png";